/**
 * TYPE UTILS
 *
 * Utils related to checking and validating types.
*/

/**
 * Type guard that can be used to determine if the passed value is not null or undefined.
 * Use this if you're not sure if what you're testing will be defined.
 */
export function isPresent<T>(t: T | null | undefined): t is T {
    return t !== null && t !== undefined;
}
